import React from "react";
import Banner from "../../components/Banner/Banner";
import BannerBottom from "../../components/Banner/BannerBottom";
import BestSellers from "../../components/home/BestSellers/BestSellers";
import NewArrivals from "../../components/home/NewArrivals/NewArrivals";
import Sale from "../../components/home/Sale/Sale";
import SpecialOffers from "../../components/home/SpecialOffers/SpecialOffers";
import YearProduct from "../../components/home/YearProduct/YearProduct";

const Home = () => {
  return (
    <div className="w-full mx-auto">
      <Banner />
      <BannerBottom />
      <div className="max-w-container mx-auto px-4">
        <Sale />
         {/* Tour Container Section */}
        <div className="bg-orange-50/30 border border-orange-100 p-6 md:p-8 rounded-xl shadow-sm mb-10">
          <div className="text-center mb-8">
            <h1 className="text-2xl md:text-3xl font-black text-amber-900 mb-2 tracking-wide uppercase">
              Old Delhi Highlights Tour
            </h1>
            <span className="inline-block bg-amber-700 text-white text-xs md:text-sm px-4 py-1.5 rounded-full font-bold tracking-wider uppercase shadow-sm">
              Flexible: Morning or Evening Tour
            </span>
          </div>

          {/* Timeline Wrapper */}
          <div className="relative border-l-2 border-amber-200 ml-4 md:ml-6 space-y-8">
            
            {/* Step 1 */}
            <div className="relative pl-6 md:pl-8 group">
              <div className="absolute -left-[9px] top-1.5 bg-amber-800 w-4 h-4 rounded-full border-4 border-white group-hover:bg-orange-500 transition-colors duration-300 shadow-sm"></div>
              <div>
                <h3 className="text-lg font-bold text-amber-950 mb-1 group-hover:text-amber-700 transition-colors">
                  Hotel Pickup & Arrival
                </h3>
                <p className="text-gray-600 text-sm md:text-base">
                  Convenient pickup from your hotel and direct drive to the historic <span className="text-orange-700 font-semibold">Sunehri Masjid</span> (Golden Mosque) near the Red Fort parking area.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="relative pl-6 md:pl-8 group">
              <div className="absolute -left-[9px] top-1.5 bg-amber-800 w-4 h-4 rounded-full border-4 border-white group-hover:bg-orange-500 transition-colors duration-300 shadow-sm"></div>
              <div>
                <h3 className="text-lg font-bold text-amber-950 mb-1 group-hover:text-amber-700 transition-colors">
                  The Iconic Red Fort
                </h3>
                <p className="text-gray-600 text-sm md:text-base">
                  A short walk to the <span className="text-orange-700 font-semibold">Red Fort</span> to witness the sheer scale and beauty of Delhi's most massive historic fort <span className="bg-amber-100 text-amber-800 text-xs px-2 py-0.5 rounded font-bold ml-1 inline-block">(Photo Stop Only)</span>.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="relative pl-6 md:pl-8 group">
              <div className="absolute -left-[9px] top-1.5 bg-amber-800 w-4 h-4 rounded-full border-4 border-white group-hover:bg-orange-500 transition-colors duration-300 shadow-sm"></div>
              <div>
                <h3 className="text-lg font-bold text-amber-950 mb-1 group-hover:text-amber-700 transition-colors">
                  Traditional Rickshaw Ride to Jama Masjid
                </h3>
                <p className="text-gray-600 text-sm md:text-base">
                  Hop onto a traditional <span className="text-orange-700 font-semibold">man-paddled rickshaw</span> to reach the grand <span className="text-orange-700 font-semibold">Jama Mosque</span>, built under the visionary supervision of Emperor Shah Jahan.
                </p>
              </div>
            </div>

            {/* Step 4 */}
            <div className="relative pl-6 md:pl-8 group">
              <div className="absolute -left-[9px] top-1.5 bg-amber-800 w-4 h-4 rounded-full border-4 border-white group-hover:bg-orange-500 transition-colors duration-300 shadow-sm"></div>
              <div>
                <h3 className="text-lg font-bold text-amber-950 mb-1 group-hover:text-amber-700 transition-colors">
                  Heritage Walking Tour
                </h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                  Explore and capture authentic photos of Chandni Chowk's famous alleyways: 
                  <span className="font-semibold text-gray-800 block md:inline md:ml-1">Kinari Bazaar (Wedding Street),</span>
                  <span className="font-semibold text-gray-800 block md:inline md:ml-1">Dariba Kalan (Jewelry Market),</span> and the iconic 
                  <span className="font-semibold text-gray-800 block md:inline md:ml-1">Paranthe Wali Gali (Indian Eatery Street).</span>
                </p>
              </div>
            </div>

            {/* Step 5 */}
            <div className="relative pl-6 md:pl-8 group">
              <div className="absolute -left-[9px] top-1.5 bg-amber-800 w-4 h-4 rounded-full border-4 border-white group-hover:bg-orange-500 transition-colors duration-300 shadow-sm"></div>
              <div>
                <h3 className="text-lg font-bold text-amber-950 mb-1 group-hover:text-amber-700 transition-colors">
                  Masala Chai Experience
                </h3>
                <p className="text-gray-600 text-sm md:text-base">
                  Take a rickshaw again to pause and savor the world-famous <span className="text-orange-700 font-semibold">Masala Chai</span> (spiced tea) served traditionally in a <span className="text-orange-700 font-semibold">Kulhad</span> (clay pot).
                </p>
              </div>
            </div>

            {/* Step 6 */}
            <div className="relative pl-6 md:pl-8 group">
              <div className="absolute -left-[9px] top-1.5 bg-amber-800 w-4 h-4 rounded-full border-4 border-white group-hover:bg-orange-500 transition-colors duration-300 shadow-sm"></div>
              <div>
                <h3 className="text-lg font-bold text-amber-950 mb-1 group-hover:text-amber-700 transition-colors">
                  Khari Baoli (Spice Market)
                </h3>
                <p className="text-gray-600 text-sm md:text-base">
                  Ride deep into <span className="text-orange-700 font-semibold">Asia's largest wholesale spice market</span>. Immerse your senses in the vibrant colors and rich aromas of authentic Indian spices.
                </p>
              </div>
            </div>

            {/* Step 7 */}
            <div className="relative pl-6 md:pl-8 group">
              <div className="absolute -left-[9px] top-1.5 bg-amber-800 w-4 h-4 rounded-full border-4 border-white group-hover:bg-orange-500 transition-colors duration-300 shadow-sm"></div>
              <div>
                <h3 className="text-lg font-bold text-amber-950 mb-1 group-hover:text-amber-700 transition-colors">
                  Return Journey
                </h3>
                <p className="text-gray-600 text-sm md:text-base">
                  Drive back to the parking spot and board your private car for a comfortable drop-off back to your hotel.
                </p>
              </div>
            </div>

          </div>
        </div>
        <NewArrivals />
        
        <BestSellers />
        <YearProduct />
        <SpecialOffers />
      </div>
    </div>
  );
};

export default Home;
